import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { portalApi, getCustToken, setCustToken } from '../../api';

export default function PortalLogin() {
  const [code, setCode] = useState('C001');
  const [password, setPassword] = useState('Cust@123456');
  const [err, setErr] = useState('');
  const nav = useNavigate();

  if (getCustToken()) { nav('/portal', { replace: true }); }

  const submit = async (e: any) => {
    e.preventDefault();
    try {
      const d = await portalApi('/login', { method: 'POST', body: JSON.stringify({ code, password }) });
      setCustToken(d.token);
      nav('/portal');
    } catch (e: any) { setErr(e.message); }
  };

  return (
    <div className="h-full flex items-center justify-center bg-gradient-to-br from-emerald-700 to-emerald-900 px-4">
      <form onSubmit={submit} className="bg-white p-7 rounded-2xl shadow-xl w-full max-w-sm space-y-5">
        <div className="text-center">
          <div className="text-3xl mb-1">🛒</div>
          <h1 className="text-xl font-bold">客户自助报货门户</h1>
          <p className="text-xs text-slate-400 mt-1">在线下单 · 实时查库存 · 手机电脑通用</p>
        </div>
        <input className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-emerald-500 outline-none" placeholder="客户编码" value={code} onChange={(e) => setCode(e.target.value)} />
        <input type="password" className="w-full border border-slate-200 rounded-lg px-4 py-3 text-base focus:ring-2 focus:ring-emerald-500 outline-none" placeholder="密码" value={password} onChange={(e) => setPassword(e.target.value)} />
        {err && <div className="text-red-500 text-sm text-center">{err}</div>}
        <button className="w-full bg-emerald-600 text-white rounded-lg py-3 text-base font-bold hover:bg-emerald-700 active:scale-95 transition">登 录</button>
        <div className="text-xs text-slate-400 text-center">
          演示账号 C001 / Cust@123456
          <br />
          <a href="/login" className="text-emerald-600 underline">内部员工？返回管理后台</a>
        </div>
      </form>
    </div>
  );
}
